import React from 'react';
import { CSSTransition } from 'react-transition-group';
import style from './fadeSwitchTransition.module.scss';

export const FadeSwitchTransition: React.SFC<Partial<CSSTransition.CSSTransitionProps>> = ({children, ...props}) => (
    <CSSTransition
        {...props}
        classNames={style}
        timeout={{enter: 200, exit: 100}}
        unmountOnExit={true}
    >
        <div>
            {children}
        </div>
    </CSSTransition>
);
